import AddDistributorForm from 'components/distributor/addDistributorForm';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { fetchSingleDistributor } from '../../../redux/slices/distributor';
import { useDispatch } from 'react-redux';

export default function AddDistributor() {
  const dispatch = useDispatch();
  const { distributorId = '' } = useParams();
  const [searchParams] = useSearchParams();
  const blazeVendorId = searchParams.get('blazeVendorId') || undefined;
  useEffect(() => {
    if (distributorId) {
      dispatch(fetchSingleDistributor({ distributorId, blazeVendorId }));
    }
  }, [distributorId, blazeVendorId, dispatch]);
  return (
    <CommonLayout>
      <AddDistributorForm />
    </CommonLayout>
  );
}
